import { CostCentreSearchComponentBase } from './cost-centre-search.component.base';
import { Component, Injector } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitService, CostCentreService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-cost-centre-search',
  templateUrl: './cost-centre-search.component.html',
  styleUrls: ['./cost-centre-search.component.scss']
})
export class CostCentreSearchComponent extends CostCentreSearchComponentBase {

  displayedColumns: string[] = ['businessUnit.buId', 'ccId', 'name', 'acronym', 'type', 'closed', 'actions'];

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected costCentreService: CostCentreService,
    protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, costCentreService, businessUnitService, refCodeStorage, fb, formStorage, injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.closedFilter = false;
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.businessUnitLoadSelectionList();
    this.typeLoadSelectionList();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }

  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    var transformer = this.transformAllPropertiesToModelSetters();
    return transformer;
  }

}



